import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungFreiburg() {
  return (
    <CityPageTemplate
      city="Freiburg"
      slug="freiburg"
      intro="In der sonnigsten Stadt Deutschlands lohnt es sich besonders, clever und renditeorientiert zu investieren."
      description="Unabhängige & digitale Finanzberatung für Freiburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
